import { submissionService } from './api';

const NOT_ATTACHED = 'This assignment does not have an autograder attached. Please contact your instructor.';
const NOT_READY = "This assignment's autograder is still getting ready. Please try again shortly.";
const SQL_UNAVAILABLE = 'SQL grading is unavailable right now. Please try again later.';

// Sends a submission to the right grader for its problem set.
// Returns { data } with the grader's response, or { notice: { level, message } }
// when the student should be told why it could not be graded.
export async function gradeSubmission({ isSql, problemSet, code, queryName }) {
  if (isSql) {
    // SQL is graded against the uploaded package directly, so there is no
    // Lambda to wait for; ignore lambda_id even if the upload created one.
    if (!problemSet.autograder_id) {
      return { notice: { level: 'error', message: NOT_ATTACHED } };
    }
    try {
      const data = await submissionService.runSqlAutograder({
        submission_code: code,
        autograder_id: problemSet.autograder_id,
        // Students write only the query; the server wraps it in this view.
        query_name: queryName,
      });
      return { data };
    } catch (error) {
      // 409: no usable package for this assignment. 503: grading not configured.
      if (error.status === 409) return { notice: { level: 'error', message: NOT_ATTACHED } };
      if (error.status === 503) return { notice: { level: 'error', message: SQL_UNAVAILABLE } };
      throw error;
    }
  }

  if (!problemSet.lambda_id) {
    return { notice: { level: 'info', message: NOT_READY } };
  }
  const data = await submissionService.runAutograder({
    submission_code: code,
    submission_filename: `${problemSet.submission_file}`,
    lambda_id: problemSet.lambda_id,
  });
  return { data };
}
